import React, { useState } from "react";
import "../assets/AllTabsCommon.css";
import "../assets/StartRemoteDebug.css";
import "../assets/AddDeviceRecovery.css";
import Select from "react-select";
import { postData } from "../api/restapi";

function AddDeviceRecoveryTab({ userInfo, prefilledSystemId }) {
  const [currentStep, setCurrentStep] = useState(1);
  const [systemId, setSystemId] = useState(prefilledSystemId || "");
  const [modemSsrCommand, setModemSsrCommand] = useState(null);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [validationError, setValidationError] = useState("");

  const commandOptions = [
    { value: "MODEM_SSR", label: "MODEM_SSR" },
    { value: "DEVICE_RESET", label: "DEVICE_RESET" },
  ];

  const isFormValid = () => {
    return systemId.trim() !== "" && modemSsrCommand !== null;
  };

  const handleContinue = () => {
    setValidationError("");
    
    if (!systemId.trim()) {
      setValidationError("System ID is required");
      return;
    }
    
    if (!modemSsrCommand) {
      setValidationError("Please select a command");
      return;
    }
    
    // Proceed to review step
    setCurrentStep(2);
  };

  const handleGoBack = () => {
    setCurrentStep(1);
    setSuccessMessage("");
    setErrorMessage("");
  };

  const handleSubmit = async () => {
    setErrorMessage("");
    setSuccessMessage("");
    
    const requestBody = {
      systemId: systemId,
      modemSsrCommand: modemSsrCommand.value,
      user: userInfo,
    };
    
    console.log("POST API: ", requestBody);
    
    try {
      const response = await postData("/api/v1/device-recovery", requestBody);
      console.log("Response: ", response);
      if (response.statusCode === 200) {
        setSuccessMessage("Request sent successfully!");
      } else {
        setErrorMessage(response.errorMessage || "Failed to send request.");
      }
    } catch (error) {
      setErrorMessage("Failed to send request.");
    }
  };

  const handleStartNew = () => {
    setCurrentStep(1);
    setSuccessMessage("");
    setErrorMessage("");
    setValidationError("");
    setSystemId("");
    setModemSsrCommand(null);
  };

  if (currentStep === 1) {
    return (
      <div className="content-tab-container">
        <div className="tab-heading">
          <h1>Recover Device</h1>
        </div>
        
        {validationError && (
          <div className="error-banner">
            <div className="error-message">{validationError}</div>
          </div>
        )}
        
        <div className="row">
          <div className="dropdown-section">
            <div className="dropdown-heading">
              System ID<span className="required-asterisk">*</span>
            </div>
            <input
              type="text"
              className="client-id"
              placeholder="Enter System ID"
              value={systemId}
              onChange={(e) => setSystemId(e.target.value)}
            />
          </div>
          <div className="dropdown-section">
            <div className="dropdown-heading">
              Command<span className="required-asterisk">*</span>
            </div>
            <Select
              className="dropdown multi-select"
              options={commandOptions}
              value={modemSsrCommand}
              onChange={(value) => setModemSsrCommand(value)}
              placeholder="Select Command"
            />
          </div>
        </div>
        <div className="submit-button-section">
          <button
            className="submit-button"
            onClick={handleContinue}
            disabled={!isFormValid()}
          >
            Continue
          </button>
        </div>
      </div>
    );
  }

  // Step 2: Review Page
  return (
    <div className="content-tab-container">
      <div className="tab-heading">
        <h1>Recover Device</h1>
      </div>
      
      <div className="review-section">
        <h3>Review your selection:</h3>
        
        <div className="review-cards">
          <div className="review-card">
            <h4>Device Recovery Request</h4>
            <div className="review-card-content">
              <div className="review-item">
                <span className="review-label">System ID:</span>
                <span className="review-value">{systemId}</span>
              </div>
              <div className="review-item">
                <span className="review-label">Command:</span>
                <span className="review-value">{modemSsrCommand?.label}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {successMessage && (
        <div className="success-banner">
          <div className="success-message">{successMessage}</div>
          <button className="submit-button" onClick={handleStartNew}>
            Start New Request
          </button>
        </div>
      )}
      
      {errorMessage && (
        <div className="error-banner">
          <div className="error-message">{errorMessage}</div>
        </div>
      )}
      
      {!successMessage && !errorMessage && (
        <div className="review-actions">
          <button className="go-back-button" onClick={handleGoBack}>
            &lt; Go Back
          </button>
          <button className="submit-button" onClick={handleSubmit}>
            Submit
          </button>
        </div>
      )}
    </div>
  );
}

export default AddDeviceRecoveryTab;
